// extracted by mini-css-extract-plugin
var _1 = "ContinuousPlayStreakModal__buttonsSingleCta--VTNxZ";
var _2 = "ContinuousPlayStreakModal__headingContent--XVReI";
var _3 = "ContinuousPlayStreakModal__illustration--wYecB";
var _4 = "ContinuousPlayStreakModal__illustrationWrap--RZKC2";
export { _1 as "buttonsSingleCta", _2 as "headingContent", _3 as "illustration", _4 as "illustrationWrap" }
